import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import Register from '../Authentication/Register'
import BoxContainerV2 from '../Reusables/BoxContainerV2'
import PageTitle from '../Reusables/PageTitle';
import dynamic from 'next/dynamic';

const StandBuilders = dynamic(() => import('./StandBuilders'));
const Organisers = dynamic(() => import('./Organisers'));

const ExhibitionLoginCard = ({title, type = null}) => {
    return (
        <BoxContainerV2
            className="mt-1 mb-6"
        >

            <Card
                sx={{
                    // height: 835
                }}
                className="p-0"
                elevation={0}
            >
                <CardHeader 
                    className="pl-4 fw-bold" 
                    title={<PageTitle className="p-0 m-0 dark-grey fw-semi-bold text-center" as="h1">{title}</PageTitle>}
                    sx={{
                        // color: 'primary.main'
                    }}
                />
                <Divider />

                <CardContent
                    className="p-0"
                >
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            { type == 'stand_builder' && <StandBuilders /> }
                            { type == 'organiser' && <Organisers /> }
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Register 
                                type={type}
                                styles={{
                                    height: '100%',
                                    minHeight: '800px'
                                }} 
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </BoxContainerV2>
    )
}

export default ExhibitionLoginCard